import React, { useEffect, useState, useContext, useMemo, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from 'react-select';
import { useSelector } from "react-redux";
import axios from "axios";
import Box from "@mui/material/Box";
import Loader from "../CommonLoader";
import ReactApexChart from "react-apexcharts";
import InprogressIcon from "../../../Icons/work-in-progress-unscreen.gif";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";
import DoneIcon from "@mui/icons-material/Done";
import calendarpng from "./../Asset/New_Assert/ESO_Icon/Filter.svg";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { Commonfun, datezonechange, removeDuplicateDate } from './../Commonfun';
import moment from "moment";
import { AppContext } from "../../../Context/Context";
import LinkIcon from '@mui/icons-material/Link';
import { Tooltip } from "@mui/material";
import { timezonechange } from './../Commonfun';
import { timezoneval } from './../Commonfun';
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import CommonAlert from "../../../Commonalert/commonalert";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import { Breadcrumbs, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import useMediaQuery from '@mui/material/useMediaQuery';
import ApexCharts from "react-apexcharts";
import DatagridComp from "../DatagridComp";
import PdfandCsv from "../PdfandCsv";
import NewLoader from "../NewLoader"
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import { Container, Grid } from '@mui/material';

const BrandMentions = () => {

  const isMobile = useMediaQuery('(max-width:600px)');
  const isTablet = useMediaQuery('(min-width:600px) and (max-width:900px)');
  const isDesktop = useMediaQuery('(min-width:900px)');
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const [cardData, setCardData] = useState([]);
  const rows = cardData ?? [];
  const [newloading, setnewLoading] = useState(false);
  const [modalIsOpen, SetmodalIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [BrandTerm, SetBrandTerm] = useState("");
  const [AdditionalTerm, SetAdditionalTerm] = useState("");
  const [Sentiment, SetSentiment] = useState({ value: 'all', label: 'All' });
  const [prevSentiment, setPrevSentiment] = useState("");
  const [ErrPop, SetErrPop] = useState("");
  const [erraddterm, SetErraddterm] = useState("");
  const [sentimentErr, SetSentimentErr] = useState("");
  const [ShowAnalyzedTable, SetShowAnalyzedTable] = useState(false);
  const [ShowInProgress, SetShowInProgress] = useState(false);
  const [InProgressMsg, SetInProgressMsg] = useState("");
  const [autoheightval, SetAutoheightval] = useState(true)
  const [faqData, setfaqData] = useState("2")
  const [toggle, setToggle] = useState(false);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [jobDate, setjobDate] = useState("");
  const [brandMentionsPlan, setbrandMentionsPlan] = useState({ status: true, error: "" });
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);

  const navigate = useNavigate();
  const closeModal = () => {
    SetmodalIsOpen(false);
    SetErrPop("");
    SetErraddterm("")
  };
  const OpenModal = () => {
    SetmodalIsOpen(true);
  };
  const apihandleClose = () => {
    SetShowAnalyzedTable(true);
    SetShowInProgress(false);
    SetInProgressMsg('');
    setapiOpen(false);
    // window.location.reload();
  };
  const columns = useMemo(() => [


    {
      field: "brand_name",
      headerName: "Brand Name",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      disableClickEventBubbling: true,
      renderCell: (cardData) => {
        if (
          cardData.row.brand_name !== null &&
          cardData.row.brand_name !== ""
        ) {
          return cardData.row.brand_name;
        } else {
          return "-";
        }
      },
    },
    {
      field: "additional_info",
      headerName: "Additional Info",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableClickEventBubbling: true,
      sortable: false,
      renderCell: (cardData) => {
        if (
          cardData.row.additional_info !== null &&
          cardData.row.additional_info !== ""
        ) {
          return cardData.row.additional_info;
        } else {
          return "-";
        }
      },
    },

    {
      field: "url",
      headerName: "URL",
      minWidth: 380,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      description: "URL of the web page",
      disableClickEventBubbling: true,
      renderCell: (cardData) => {
        const url = cardData.row.url;
        let baseUrl = cardData.row.url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.url.split("/").slice(3).join("/");

        if (url !== null && url !== "") {
          return (
            <Tooltip title={url}>
              <div className="prefered_url_external02">
                <a className="table_links" href={url} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', flexDirection: 'column' }}>
                  <span className="spanlink" style={{ color: "#044792" }} >
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }}>{remaining}</span>
                </a>
              </div>
            </Tooltip>
          );
        } else {
          return "-";
        }
      },
    },
    {
      field: "category",
      headerName: "Category",
      description: "The type or classification of the website mentioning your brand.",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      disableClickEventBubbling: true,
    },
    {
      field: "title",
      headerName: "Title",
      description: "The page title where your brand was mentioned.",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      disableClickEventBubbling: true,
    },

    {
      field: "meta_description",
      headerName: "Meta Description",
      description: "The summary text that appears in search results for the mentioning page",
      minWidth: 300,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableClickEventBubbling: true,
      sortable: false,
    },
    {
      field: "sentiment",
      headerName: "Sentiment",
      description: "The emotional tone detected in the brand mention",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableClickEventBubbling: true,
      sortable: true,
    },

    {
      field: "date_of_request",
      headerName: "Date of request",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      disableClickEventBubbling: true,
      valueGetter: (params) => {
        const dateStr = params.row?.date_of_request;
        if (!dateStr) return null;
        const parsed = new Date(dateStr);
        if (!isNaN(parsed)) return parsed;
        const fixedStr = dateStr.replace(/(\d{2}:\d{2})$/, "$1:00");
        return new Date(fixedStr);
      },
      renderCell: (cardData) => {
        if (
          cardData.row.date_of_request !== null &&
          cardData.row.date_of_request !== ""
        ) {
          return datezonechange(cardData?.row?.date_of_request)
        } else {
          return "-";
        }
      },
    },

    {
      field: "status",
      headerName: "Status",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableClickEventBubbling: true,
      sortable: false,
      renderCell: (carddata) => {
        if (carddata.row.status == true || carddata.row.status == "true") {
          return (
            <>
              <DoneIcon />
            </>
          );
        }
      },
    },
  ], []);

  const [PositivePie, SetPositivePie] = useState(0);
  const [NegativePie, SetNegativePie] = useState(0);
  const [NeutralPie, SetNeutralPie] = useState(0);
  const [pieseriesData, SetpieseriesData] = useState([]);

  const pieseries = pieseriesData;

  const pieoptions = {
    chart: {
      type: "donut",
      height: 350,
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          "<div class='custom_pie_tool_tip'>" +
          w.config.labels[seriesIndex] +
          "</div>"
        );
      },
    },
    labels: [
      `Positive - ${Sentiment.value == 'Positive' || Sentiment.value == 'all' ? PositivePie : '0.00'}`,
      `Negative - ${Sentiment.value == 'Negative' || Sentiment.value == 'all' ? NegativePie : '0.00'}`,
      `Neutral - ${Sentiment.value == 'Neutral' || Sentiment.value == 'all' ? NeutralPie : '0.00'}`,
    ],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: "100%",
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
    legend: {
      position: isMobile || isTablet ? "bottom" : "right",
      horizontalAlign: "center",
      verticalAlign: "center"
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
        },
      },
    }
  };


  const Submit = async () => {
    setnewLoading(true);
    setTableLoading(true);
    SetErrPop("");
    SetErraddterm("")
    var termsval = 1
    if (BrandTerm === "") {
      SetErrPop("Please enter brand name");
      termsval = 2;
    }
    if (AdditionalTerm == "") {
      SetErraddterm("Please enter additional terms")
      termsval = 2;
    }
    if (termsval == 1) {
      setCardData([]);
      SetShowAnalyzedTable(false);
      SetShowInProgress(false);
      SetInProgressMsg("");
      setnewLoading(true);
      SetmodalIsOpen(false)
      try {
        const datavalue = await axios.get(
          `${process.env.REACT_APP_API_URL}brandmentions/brand_mentions/?user_domain_id=${esodata.domaindata.value.header_selected}&brand_name=${BrandTerm}&additional_terms=${AdditionalTerm}&new_scrap=True`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          }
        ).catch((error) => {
          if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
            setapiOpen(true);
            setCardData("");
            SetAutoheightval(true)
            setapierrorMsg(error?.response?.data?.error)
          }
          else if (error?.code == "ERR_NETWORK") {
            navigate('/errorpages')
          }
        });
        setLoading(false);
        if (datavalue?.data?.job_date) {
          setjobDate(datavalue?.data?.job_date)
        }
        else {
          setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"))
        }

        if (datavalue.data) {
          if (datavalue.data.status === "completed") {
            SetBrandTerm("");
            SetAdditionalTerm("");
            SetSentiment("");

            if (datavalue.data.data && datavalue?.data?.data?.length > 0) {
              const newData = datavalue.data.data.map((obj, index) => {
                return { ...obj, sid: index + 1 };
              });
              SetAutoheightval(false)
              setCardData(newData);
              closeModal();
              SetShowAnalyzedTable(true);
            }
          } else if (datavalue.data.status === "in_progress") {
            SetShowAnalyzedTable(false);
            SetShowInProgress(true);
            SetInProgressMsg(datavalue.data.message);
            setCardData("");
            SetAutoheightval(true)
            setapiOpen(true);
            setapierrorMsg('After analyze completion we will send a mail. Thank you');
            closeModal();
          }
        }
      } catch (err) {
        setnewLoading(false);
        if (err.response) {
          if (err.response.data.error) {
            setCardData("");
            SetAutoheightval(false)
            SetErrPop(err.response.data.error);
          }
          if (err.response.data.status) {
            if (err.response.data.status === "in_progress") {
              SetShowInProgress(true);
              SetInProgressMsg(err.response.data.message);
              setCardData("");
              SetAutoheightval(false)
              closeModal();
              return false;
            }
          }
        } else {
          setCardData("");
          SetErrPop("");
        }
      }
    }
    setTableLoading(false);
    setnewLoading(false);
  };

  const GetHistoryBrandMentions = async (jobid = "") => {
    setLoading(true);
    setTableLoading(false);
    setCardData([])
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}brandmentions/brand_mentions/?user_domain_id=${esodata.domaindata.value.header_selected}&new_scrap=False&job_id=${jobid}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      if (datavalue?.data) {
        if (datavalue?.data?.data) {
          const newData = datavalue.data.data.map((obj, index) => {
            return { ...obj, sid: index + 1 };
          });
          if (datavalue?.data?.job_date) {
            setjobDate(datavalue?.data?.job_date)
          }
          else {
            setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"))
          }
          if (newData && newData.length > 0) {
            SetAutoheightval(false)
            setCardData(newData);
          }
          else {

            SetAutoheightval(true)
            setCardData("");
          }
          SetShowAnalyzedTable(true);

        }
        if (datavalue.data.error) {
          toast.error(datavalue.data.error, {

            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      }
    } catch (err) {

      if (err.response.data.error) {
        SetShowAnalyzedTable(true);
        toast.error(err.response.data.error, {

          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else if (err.response.data.message) {
        SetShowInProgress(true);
        SetInProgressMsg(err.response.data.message);
      } else {
        SetShowAnalyzedTable(true);
        toast.error(err.response.data.message, {

          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }
    setTableLoading(false);
    setLoading(false);
  };

  const GetHistoryBrandGraph = async (jobid = "") => {
    setLoading(true);
    try {
      const datavalueGraph = await axios.get(
        `${process.env.REACT_APP_API_URL}brandmentions/sentiment_count/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobid}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      setLoading(false);
      var PositiveGraph = 0;
      var NegativeGraph = 0;
      var NuetralGraph = 0;

      if (datavalueGraph?.data) {
        PositiveGraph = parseFloat(datavalueGraph?.data?.positive_percentage);
        NegativeGraph = parseFloat(datavalueGraph?.data?.negative_percentage);
        NuetralGraph = parseFloat(datavalueGraph?.data?.neutral_percentage);
      }

      SetPositivePie(PositiveGraph);
      SetNegativePie(NegativeGraph);
      SetNeutralPie(NuetralGraph);
      // SetpieseriesData([PositiveGraph, NegativeGraph, NuetralGraph]);
      const selectedSentiment = Sentiment.value == 'Positive' ? [PositiveGraph, 0, 0] : Sentiment.value == 'Neutral' ? [0, 0, NuetralGraph] : [0, NegativeGraph, 0];
      if (Sentiment.value === 'all') {
        SetpieseriesData([PositiveGraph, NegativeGraph, NuetralGraph]);
      } else {
        SetpieseriesData(selectedSentiment);
      }
    } catch (err) {
      setLoading(false);
    }
  };
  const checkUserPlan = async () => {
    const brandMentionsP = await Utils("brand_mentions", ApiToken);
    if (brandMentionsP.status) {
      GetHistoryBrandMentions();
      GetHistoryBrandGraph();
      GetReportJobDates();
      faqdatafun();
    }
    setbrandMentionsPlan(brandMentionsP);
  };


  useEffect(() => {
    checkUserPlan();
  }, []);

  const [OpenModalJob, SetOpenModalJob] = useState(false);
  const CloseModalJobTrigger = () => {
    if (prevdEngineoption) {
      setSelectval(prevdEngineoption);
      SetdEngineoption(prevdEngineoption);
    }
    SetSentiment(prevSentiment);
    SetOpenModalJob(false);
    SetSentimentErr("");
    SetvalidationFiter("");
  };
  const OpenModalJobTrigger = () => {
    SetOpenModalJob(true);
  };
  const [completedate, Setcompletedate] = useState([]);
  const [Selectval, setSelectval] = useState('');
  const [validationFiter, SetvalidationFiter] = useState("");
  const [jobvalsel, SetJobvalsel] = useState("")

  const TriggerFilter = async () => {
    setTableLoading(true);
    setPrevdEngineoption(dEngineoption);
    setPrevSentiment(Sentiment);
    let hasError = 1;
    if (Selectval === '') {
      SetvalidationFiter("Please select the completed date");
      hasError = 2;
    } else {
      SetvalidationFiter("");
    }
    if (Sentiment === '') {
      SetSentimentErr("Please select the sentiment for filter purpose");
      hasError = 2;
    } else {
      SetSentimentErr("");
    }
    if (hasError == 2) {
      return false;
    }
    else if (Sentiment.label === 'all') {
      let JobId;
      if (Selectval) {
        JobId = Selectval.value;
      } else {
        JobId = jobvalsel;
      }
      GetHistoryBrandMentions(JobId);
      SetJobvalsel(JobId);
      GetHistoryBrandGraph(JobId);
      SetOpenModalJob(false);
      SetSentimentErr("");
      SetvalidationFiter("");
    }
    else {
      let JobId;
      if (Selectval) {
        JobId = Selectval.value;
      } else {
        JobId = jobvalsel;
      }
      SetJobvalsel(JobId)
      GetHistoryBrandGraph(JobId);
      SetOpenModalJob(false);
      SetSentimentErr("");
      SetvalidationFiter("");

      try {
        const datavalue = await axios.get(
          `${process.env.REACT_APP_API_URL}brandmentions/brand_mentions/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${JobId}&sentiment=${Sentiment.value}`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          }
        ).catch((error) => {
          if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
          }
          else if (error?.code == "ERR_NETWORK") {
            navigate('/errorpages')
          }
        });
        setLoading(false);
        if (datavalue?.data?.job_date) {
          setjobDate(datavalue?.data?.job_date)
        }
        else {
          setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"))
        }
        if (datavalue?.data?.data.length > 0) {
          const newData = datavalue.data.data.map((obj, index) => {
            return { ...obj, sid: index + 1 };
          });
          SetAutoheightval(false)
          setCardData(newData);
          SetShowAnalyzedTable(true);
          SetOpenModalJob(false);
          SetSentimentErr("");
          SetvalidationFiter("");
        }
        else {
          SetAutoheightval(true)
          setCardData("");
        }

      } catch (err) {
        console.log('filter error', err);
        setLoading(false);
      }
      setTableLoading(false);
    }
  };
  const pdfdown = async () => {
    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}brandmentions/brand_mentions/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobvalsel}&sentiment=${Sentiment.value}&new_scrap=&formats=pdf&timezone=${timezoneval()}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/pdf',
            Authorization: `${ApiToken}`,
          },
        });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("BrandMention", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);
  }
  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}brandmentions/brand_mentions/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobvalsel}&sentiment=${Sentiment.value}&new_scrap=&formats=csv&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("BrandMention", "csv", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();



        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);
  }

  const GetReportJobDates = async () => {
    setLoading(true);

    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?user_domain_id=${esodata.domaindata.value.header_selected}&job_type=brandmentions`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      setLoading(false);
      if (datavalue?.data?.jobs.length > 0) {
        // var brandMention = [];
        // datavalue?.data?.jobs.forEach((element) => {
        //   brandMention.push({ label: datezonechange(element.completed_at), value: element.id });
        // });
        const uniqueByCompletedAt = removeDuplicateDate(datavalue?.data?.jobs);
        SetdEngineoption(uniqueByCompletedAt[0]);
        setPrevdEngineoption(uniqueByCompletedAt[0]);
        Setcompletedate(uniqueByCompletedAt);
        setSelectval(uniqueByCompletedAt[0])
      }

    } catch (err) {
      setLoading(false);
    }
  };

  const [dEngineoption, SetdEngineoption] = useState({
    completed_at: "Select Date",
    id: "Select Date",
  });
  const [prevdEngineoption, setPrevdEngineoption] = useState(null);



  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=32`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };
  function handleReset() {
    SetdEngineoption("");
    SetSentiment("");
    SetAdditionalTerm("");
    SetBrandTerm("");
  }

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleModelPopUp = () => {
    if (brandMentionsPlan.status) {
      OpenModalJobTrigger();
    }
  };
  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }

  return (
    <>
      {loading === true ? <Loader /> : null}
      {
        newloading === true ? <NewLoader /> : null
      }
      <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Brand Mentions 1</title>
        </Helmet>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />

        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={4}>
                <div>
                  <h1 className="dashboard_header">
                    Brand Mentions
                    <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                  </h1>
                </div>
              </Grid>
              <Grid item xs={12} md={8}>
                <div className="top_breadcrumb_menu">
                  <div className="exportpdf_outer">
                    <div className="breadcrumb-wrapper">
                      <CommonBreadCrumb breadcrumbValue={[
                        { title: 'Brand Mentions', activeColor: true }
                      ]} />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box-time">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={6}>
                <div className="time_zone">
                  <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                  <span className="timezone-val">{timezoneval()}</span>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="drop_down_button" >
                  <button
                    title="Analyze"
                    className="btn_dashboard"
                    onClick={() => {
                      OpenModal();
                    }}
                    disabled={!brandMentionsPlan.status}
                  >
                    Analyze
                  </button>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Container maxWidth={false} className="graph-container">
          <Box className="graph-box">
            <Grid container className="graph-grid">
              <Grid item xs={12} md={12}>
                <div>
                  {ShowAnalyzedTable === true && brandMentionsPlan.status &&
                    (PositivePie == 0 && NegativePie == 0 && NeutralPie == 0) === false ? (
                    <div className="pie-chart-outer">
                      <div className="pie-chart-inner">
                        <ApexCharts options={pieoptions} series={pieseries} type="donut" height={350} />
                      </div>
                    </div>
                  ) : null}
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>




        <Container maxWidth={false} className="dashboard-container">
          <Box className="grid_table_shodow">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={12}>
                <div className="cnt_audit_outer_wrap">
                  {(ShowAnalyzedTable === true && brandMentionsPlan.status) ? (
                    <DatagridComp className="datagrid_custom_scroll"
                      columns={columns}
                      rows={rows}
                      autoheightval={autoheightval}
                      datagridval={2}
                      tableLoading={tableLoading}
                      handleModelPopUp={handleModelPopUp}
                      handleDownlodingCSV={handleDownlodingCSV}
                      handleDownlodingPDF={handleDownlodingPDF}
                      DownloadShowFile={true}
                      customFilter={true}
                      DownloadShowPDF={1}
                      DownloadShowCSV={2}
                    />
                  ) : null}
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>


        <Container maxWidth={false} className="footer-container">
          <Box className="footer-box">
            <Grid container className="footer-grid">
              <Grid item xs={12} md={6}>
                <div className="footer-left">
                  <p className="footer-text">
                    All Rights Reserved Copyright © 2025 |
                    <a href="https://www.egrovesys.com/" target="blank">
                      <span className="footer-brand">eGrove Systems</span>
                    </a>
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="footer-right">
                  <p>{/* Add content if needed */}</p>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>


        <div className="cnt_audit_outer_wrap">
          <div >


            {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

          </div>

          {!brandMentionsPlan.status &&
            <Freeaudit planStatus={brandMentionsPlan} />
          }
        </div>



        {(ShowInProgress == true && brandMentionsPlan.status) ? (
          <div className="show_in_progress_brand_mention">
            <div className="wrapperAlert">
              <div className="contentAlert">
                <div className="topHalf">
                  <p>
                    <img src={InprogressIcon} />
                  </p>
                  <h1>{InProgressMsg}</h1>

                  <ul className="bg-bubbles">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                  </ul>
                </div>
              </div>
            </div>{" "}
          </div>
        ) : null}


        <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />

        <Dialog
          open={modalIsOpen}
          onClose={closeModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="competitor_test_filter job_date_filter keyword_edit_form"
        >
          <DialogTitle className="keyword-dialog-header">{"Brand Mention Analysis"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div className="cnt_hdr_blw_wrap row">
                <div className="brand_mentions_form">
                  <div>
                    <label>Brand Name:</label>
                  </div>
                  <div>
                    <input
                      type="text"
                      value={BrandTerm}
                      placeholder="Enter Brand Name"
                      defaultValue={BrandTerm}
                      onChange={(e) => {
                        SetBrandTerm(e.target.value);
                      }}
                    />
                  </div>
                  <div className="err brand_mention_err">{ErrPop}</div>
                  <div style={{ marginTop: "20px" }}>
                    <label>Additional terms:</label>
                  </div>
                  <div>
                    <input
                      type="text"
                      value={AdditionalTerm}
                      placeholder="Enter Additional Terms"
                      defaultValue={AdditionalTerm}
                      onChange={(e) => {
                        SetAdditionalTerm(e.target.value);
                      }}
                    />
                  </div>

                </div>
              </div>
              <div className="err brand_mention_err">{erraddterm}</div>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-action-button">
            <button
              className="keyword-submit"
              onClick={Submit}
              style={{ cursor: "pointer" }}
            >
              Submit
            </button>
            <button className="keyword-cancel" onClick={closeModal}>
              close
            </button>
            <button
              className="form_submit_btn"
              style={{ cursor: "pointer" }}
              onClick={handleReset}
            >
              Reset
            </button>
          </DialogActions>
        </Dialog>
      </div>

      <Dialog
        open={OpenModalJob}
        onClose={CloseModalJobTrigger}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter"
      >
        <DialogTitle className="keyword-dialog-header">{"Filter By"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="cnt_hdr_blw_wrap">
              <div>
                <div className="">
                  <div >
                    <span>Completed Date</span>
                    <Select
                      className="myClass"
                      value={dEngineoption}
                      options={completedate}
                      placeholder="Select..."
                      labelField="completed_at"
                      valueField="id"
                      onChange={(values) => {
                        setSelectval(values);
                        SetdEngineoption(values);
                      }}
                      styles={customDropdownStyles()}
                      menuPortalTarget={document.body}
                    />
                  </div>
                </div>

                <div className="col">
                  <span className="text-error">{validationFiter}</span>
                </div>
              </div>
              <div>
                <div>
                  <label>Sentiment for filter purpose:</label>
                </div>
                <div>
                  <Select
                    value={Sentiment}
                    options={[
                      { value: 'all', label: 'All' },
                      { value: 'Positive', label: 'Positive' },
                      { value: 'Negative', label: 'Negative' },
                      { value: 'Neutral', label: 'Neutral' },
                    ]}
                    placeholder="Select..."
                    defaultValue={{ value: 'all', label: 'All' }}
                    onChange={(e) => {
                      SetSentiment(e);
                    }}
                    styles={customDropdownStyles()}
                    menuPortalTarget={document.body}
                  >
                  </Select>
                </div>
                <div className="col">
                  <span className="text-error">{sentimentErr}</span>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button
            className="keyword-submit"
            onClick={TriggerFilter}
          >
            Submit
          </button>
          <button className="keyword-cancel" onClick={CloseModalJobTrigger}>
            close
          </button>
          <button
            className="form_submit_btn"
            style={{ cursor: "pointer" }}
            onClick={handleReset}
          >
            Reset
          </button>
        </DialogActions>
      </Dialog>
      {!openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />
      }
    </>
  );
};
export default BrandMentions; 
